import React, { Fragment } from 'react'

import ComponentLoader from '@scoir/components-core/dist/components/ComponentLoader'
import Icon from '@scoir/components-core/dist/components/Icon'
import Module from '@scoir/components-core/dist/components/Module'
import Table from '@scoir/components-table/dist/Table'
import keyboardLeftArrowIcon from 'icons/keyboard-arrow-left.svg'
import { isEqual, map } from 'lodash'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'
import qs from 'querystring'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import api from 'common/api'

import './index.scss'

const DEFAULT_RESULTS = {
  Total: 0,
  Visits: [],
}

const formatTimeWithZone = (time, zone) => moment.tz(time, zone).format('hh:mmA')

export class UpcomingVisitsListRoute extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loaded: false,
      results: DEFAULT_RESULTS,
    }
  }
  componentDidMount() {
    document.title = 'Scoir - Upcoming Visits'
  }
  fetch({ from, pageSize }, selectedSchools = this.props.selectedSchools) {
    const params = qs.stringify({
      from,
      pageSize,
      ids: map(selectedSchools, 'Id'),
    })
    api
      .get(`/api/highschools/visits?${params}`)
      .then((results) =>
        this.setState({
          loaded: true,
          results,
        }),
      )
      .catch(() =>
        this.setState({
          loaded: true,
          results: DEFAULT_RESULTS,
        }),
      )
  }
  componentDidUpdate(prevProps, prevState) {
    if (!isEqual(prevProps.selectedSchools, this.props.selectedSchools)) {
      this.fetch(prevState.tableContext, this.props.selectedSchools)
    }
  }
  render() {
    return (
      <div className="calendar-upcoming-events-route">
        <div className="calendar-link-container">
          <Link to={`${import.meta.env.BASE_URL}/recruit/visits/view/week`}>
            <Icon
              def={keyboardLeftArrowIcon}
              size="sm"
              beforeText
            />
            Back to Calendar
          </Link>
        </div>
        <Module>
          <h2 className="header">Upcoming College Visits</h2>
          <ComponentLoader loaded={this.state.loaded}>
            <Table
              total={this.state.results.Total}
              records={this.state.results.Visits}
              keyedBy="Id"
              canChangePageSize={true}
              onTableChange={(context) => {
                this.setState({
                  tableContext: context,
                })
                this.fetch(context)
              }}
              columnDefs={[
                {
                  headerText: 'Date',
                  renderCell: (record) => moment(record.StartTime).format('ddd MMM Do, YYYY'),
                },
                {
                  headerText: 'Time',
                  renderCell: (record) => (
                    <Fragment>
                      {formatTimeWithZone(record.StartTime, record.StartTimeZone)} -{' '}
                      {formatTimeWithZone(record.EndTime, record.StartTimeZone)}{' '}
                      {moment.tz(record.StartTime, record.StartTimeZone).format('z')}
                    </Fragment>
                  ),
                },
                {
                  headerText: 'High School',
                  renderCell: (record) => record.HighSchoolName,
                },
              ]}
            />
          </ComponentLoader>
        </Module>
      </div>
    )
  }
}

UpcomingVisitsListRoute.propTypes = {
  selectedSchools: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default connect((state) => ({
  selectedSchools: state.visitSelectedSchools,
}))(UpcomingVisitsListRoute)
